//chapter1
export default {
    id : 2,//chapter number
    title : '02. FMEA 개요 (2) - RISK 평가와 FMEA',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c02.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'RISK 평가와 FMEA',
            ],
            body2 : [
                'RISK 평가와 FMEA에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '02.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '고객 RISK와 개발은 별개의 문제이다.',//html available
                    answer : "2",
                    explain : '개발과정은 RISK를 해결하는 과정이 가장 중요하다.'
                },
                {
                    type : 'ox',
                    question : 'FMEA는 고객의 RISK를 평가하는 것이다.',//html available
                    answer : "1",
                    explain : 'FMEA를 도구로하여 객관적인 RISK 평가가 가능하다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. RISK 평가의 중요성</h3>
                        <li>현재의 방법은 RISK를 만들고 있음</li>
                        <li>품질 시스템은 RISK 관리의 강화를 요구함</li>
                        <p class="mg10"></p>
                        <h3>2. RISK 평가의 방법</h3>
                        <li>심각도, 발생도, 검출도에 의한 RISK 평가</li>
                        <p class="mg10"></p>
                        <h3>3. FMEA 기본 정보 구성체계</h3>
                        <li>고장의 분류와 분류에 따른 RISK 평가 개념</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c02.mp4',
        },
    ]
}